export enum PermissionEnum {
    // project
    PROJECT_READ = 'project:read',
    PROJECT_CREATE = 'project:create',
    PROJECT_UPDATE = 'project:update',
    PROJECT_DELETE = 'project:delete',

    // client
    CLIENT_READ = 'client:read',
    CLIENT_CREATE = 'client:create',
    CLIENT_UPDATE = 'client:update',
    CLIENT_DELETE = 'client:delete',

    // user
    USER_READ = 'user:read',
    USER_CREATE = 'user:create',
    USER_UPDATE = 'user:update',
    USER_DELETE = 'user:delete',

    // camera
    RESELLER_CAMERA_READ = 'resellerCamera:read',
    RESELLER_CAMERA_CREATE = 'resellerCamera:create',
    RESELLER_CAMERA_UPDATE = 'resellerCamera:update',
    RESELLER_CAMERA_DELETE = 'resellerCamera:delete',

    // All Users
    ALL_USERS_READ = 'allUsers:read',
    ALL_USERS_CREATE = 'allUsers:create',
    ALL_USERS_UPDATE = 'allUsers:update',
    ALL_USERS_DELETE = 'allUsers:delete',

    // Sign In logs
    SIGN_IN_LOGS_READ = 'signInLogs:read',
    SIGN_IN_LOGS_CREATE = 'signInLogs:create',
    SIGN_IN_LOGS_UPDATE = 'signInLogs:update',
    SIGN_IN_LOGS_DELETE = 'signInLogs:delete',

    // console User
    CONSOLE_USER_READ = 'consoleUser:read',
    CONSOLE_USER_CREATE = 'consoleUser:create',
    CONSOLE_USER_UPDATE = 'consoleUser:update',
    CONSOLE_USER_DELETE = 'consoleUser:delete',

    // Support
    SUPPORT_READ = 'support:read',
    SUPPORT_CREATE = 'support:create',
    SUPPORT_UPDATE = 'support:update',
    SUPPORT_DELETE = 'support:delete',

    // Public Api Request
    PUBLIC_API_REQUEST_READ = 'publicApiRequest:read',
    PUBLIC_API_REQUEST_CREATE = 'publicApiRequest:create',
    PUBLIC_API_REQUEST_UPDATE = 'publicApiRequest:update',
    PUBLIC_API_REQUEST_DELETE = 'publicApiRequest:delete',

    // TimeLapse Camera
    TIMELAPSE_CAMERA_READ = 'timelapseCamera:read',
    TIMELAPSE_CAMERA_CREATE = 'timelapseCamera:create',
    TIMELAPSE_CAMERA_UPDATE = 'timelapseCamera:update',
    TIMELAPSE_CAMERA_DELETE = 'timelapseCamera:delete',

    // LiveCamera
    LIVE_CAMERA_READ = 'liveCamera:read',
    LIVE_CAMERA_CREATE = 'liveCamera:create',
    LIVE_CAMERA_UPDATE = 'liveCamera:update',
    LIVE_CAMERA_DELETE = 'liveCamera:delete',
    // SiteGallery
    SITE_GALLERY_READ = 'siteGallery:read',
    SITE_GALLERY_CREATE = 'siteGallery:create',
    SITE_GALLERY_UPDATE = 'siteGallery:update',
    SITE_GALLERY_DELETE = 'siteGallery:delete',
    // drone
    DRONE_READ = 'drone:read',
    DRONE_CREATE = 'drone:create',
    DRONE_UPDATE = 'drone:update',
    DRONE_DELETE = 'drone:delete',

    // client Installation
    CLIENT_INSTALLATION_READ = 'clientInstallation:read',
    CLIENT_INSTALLATION_CREATE = 'clientInstallation:create',
    CLIENT_INSTALLATION_UPDATE = 'clientInstallation:update',
    CLIENT_INSTALLATION_DELETE = 'clientInstallation:delete',

    // client Installation
    PROJECT_INSTALLATION_READ = 'projectInstallation:read',
    PROJECT_INSTALLATION_CREATE = 'projectInstallation:create',
    PROJECT_INSTALLATION_UPDATE = 'projectInstallation:update',
    PROJECT_INSTALLATION_DELETE = 'projectInstallation:delete',

    // Recce
    SITE_RECCE_READ = 'siteRecce:read',
    SITE_RECCE_CREATE = 'siteRecce:create',
    SITE_RECCE_UPDATE = 'siteRecce:update',
    SITE_RECCE_DELETE = 'siteRecce:delete',

    // GRIDWALL
    GRIDWALL_REQUEST_READ = 'gridwallRequest:read',
    GRIDWALL_REQUEST_CREATE = 'gridwallRequest:create',
    GRIDWALL_REQUEST_UPDATE = 'gridwallRequest:update',
    GRIDWALL_REQUEST_DELETE = 'gridwallRequest:delete',

    // purchase Order
    ASSET_PURCHASE_ORDER_READ = 'assetPurchaseOrder:read',
    ASSET_PURCHASE_ORDER_CREATE = 'assetPurchaseOrder:create',
    ASSET_PURCHASE_ORDER_UPDATE = 'assetPurchaseOrder:update',
    ASSET_PURCHASE_ORDER_DELETE = 'assetPurchaseOrder:delete',

    // purchase Order
    INTERNAL_APPLICATION_READ = 'internalApplication:read',
    INTERNAL_APPLICATION_CREATE = 'internalApplication:create',
    INTERNAL_APPLICATION_UPDATE = 'internalApplication:update',
    INTERNAL_APPLICATION_DELETE = 'internalApplication:delete',
    LIVE_LAPSE_LOGS_READ = 'liveLapseLogs:read',
    MULTI_IMAGE_LOGS_READ = 'multiImageLogs:read',
    PUBLIC_API_LOGS_READ = 'publicApiLogs:read',
    SCHEDULED_REPORTS_READ = 'scheduledReports:read',
    PROGRESS_LINE_ACTIVITY_READ = 'progressLineActivity:read',
    COMMENTS_ACTIVITY_READ = 'commentsActivity:read',
    WHATSAPP_ACTIVITY_READ = 'whatsappActivity:read',
    BIM_SERVICED_READ = 'bimServiced:read',
    AI_SERVICED_READ = 'aiServiced:read',
    INACTIVE_USER_EMAIL_LOGS_READ = 'inactiveUserEmails:read',
    CAMERA_INSTALLATION_LOGS_READ = 'cameraInstallationLogs:read',

    // Recce
    BOX_STROAGE_READ = 'boxStorage:read',
    BOX_STROAGE_CREATE = 'boxStorage:create',
    BOX_STROAGE_UPDATE = 'boxStorage:update',
    BOX_STROAGE_DELETE = 'boxStorage:delete',

    // AI Wrong Info
    AI_WRONG_INFORMATION_READ = 'aiWrongInformation:read',
    AI_WRONG_INFORMATION_CREATE = 'aiWrongInformation:create',
    AI_WRONG_INFORMATION_UPDATE = 'aiWrongInformation:update',
    AI_WRONG_INFORMATION_DELETE = 'aiWrongInformation:delete',

    // Documents
    DOCUMENT_READ = 'document:read',
    DOCUMENT_CREATE = 'document:create',
    DOCUMENT_UPDATE = 'document:update',
    DOCUMENT_DELETE = 'document:delete',

    DAILY_ACTIVITY_READ = 'dailyActivity:read',

    // Notification
    NOTIFICATION_READ = 'notification:read',
    NOTIFICATION_CREATE = 'notification:create',
    NOTIFICATION_UPDATE = 'notification:update',
    NOTIFICATION_DELETE = 'notification:delete',

    ANNOUNCEMENT_READ = 'announcement:read',
    ANNOUNCEMENT_CREATE = 'announcement:create',
    ANNOUNCEMENT_UPDATE = 'announcement:update',
    ANNOUNCEMENT_DELETE = 'announcement:delete',

    ENABLE_AI = 'enable:create',
}
